
import React from 'react';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';
import { Volume2, VolumeX, TestTube } from 'lucide-react';
import { audioManager, AudioSettings as AudioSettingsType } from '@/utils/audioManager';

interface AudioSettingsProps {
  settings: AudioSettingsType;
  onSettingsChange: (settings: Partial<AudioSettingsType>) => void;
}

const AudioSettings: React.FC<AudioSettingsProps> = ({
  settings,
  onSettingsChange
}) => {
  const handleEnabledChange = (enabled: boolean) => {
    onSettingsChange({ enabled });
  };

  const handleVolumeChange = (value: number[]) => {
    onSettingsChange({ volume: value[0] });
  };

  const handleTestSound = async () => {
    await audioManager.testSound();
  };

  return (
    <div className="space-y-6">
      {/* Enable/Disable Sounds */}
      <div className="flex items-center justify-between py-4 border-b border-gray-100 dark:border-gray-700">
        <div className="flex items-center gap-3">
          {settings.enabled ? <Volume2 size={20} /> : <VolumeX size={20} />}
          <span className="text-lg">Sound effects</span>
        </div>
        <div className="flex items-center gap-2">
          <Switch 
            checked={settings.enabled}
            onCheckedChange={handleEnabledChange}
            className="data-[state=checked]:bg-black dark:data-[state=checked]:bg-white"
          />
          <span className="text-lg">{settings.enabled ? 'On' : 'Off'}</span>
        </div>
      </div>

      {/* Volume Control */}
      {settings.enabled && (
        <>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <Label className="text-lg">Volume</Label>
              <span className="text-sm text-gray-500">
                {Math.round(settings.volume * 100)}%
              </span>
            </div>
            <Slider
              value={[settings.volume]}
              onValueChange={handleVolumeChange}
              max={1}
              min={0}
              step={0.1}
              className="w-full"
            />
          </div>

          {/* Test Sound Button */}
          <div className="pt-4">
            <Button
              onClick={handleTestSound}
              variant="outline"
              className="flex items-center gap-2"
            >
              <TestTube size={16} />
              Test sound
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default AudioSettings;
